import { useQuery } from 'react-query'
import { ProfileApi } from '@/services/api/ProfileApiService'

const useProfile = () => {
  return useQuery(
    ['profile'],
    async () => {
      return await ProfileApi.getProfile()
    },
    {
      onError: (error: any) => {
        return error?.message || 'Profile data failed'
      },
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  )
}

export default useProfile
